import scenes from './constants'

const shouldDisplayScene = (pathname: string) => {
  if (pathname.includes(scenes.LOBBY)) {
    return false
  }
  return true
}

export default shouldDisplayScene
